import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateSecurityQuestionsComponent } from './update-security-questions/update-security-questions.component';
import {accountRouting} from './account.routing';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ChangeTempPasswordComponent } from './change-temp-password/change-temp-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TabsModule} from 'ngx-bootstrap/tabs';
import { InsertPasswordModalComponent } from './change-password/insert-password-modal/insert-password-modal.component';



@NgModule({
  declarations: [
    UpdateSecurityQuestionsComponent,
    ChangeTempPasswordComponent,
    ChangePasswordComponent,
    InsertPasswordModalComponent
  ],
  entryComponents: [
    UpdateSecurityQuestionsComponent,
    ChangeTempPasswordComponent,
    ChangePasswordComponent,
    InsertPasswordModalComponent
  ],
  imports: [
    CommonModule,
    accountRouting,
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    TabsModule.forRoot(),
  ]
})
export class AccountModule { }
